import SingleMap from "views/SingleMap";

export const mapsRoutes = (prefix = "") => {
    return [
        {
            path: `${prefix}/:id/:mainMapId?/:depth?`,
            exact: true,
            section: SingleMap,
        },
    ];
};
